export default __webpack_public_path__ + "static/media/Group 253.29c23b88.svg";